import React, { useState } from "react";
import { Button } from "react-bootstrap";

import { ListeningStatus } from "shared/config/constants";

import ChatIcon from "../../assets/images/chat.svg";
import StartRecordingIcon from "../../assets/images/start_recording.svg";
import StopRecordingIcon from "../../assets/images/stop_recording.svg";
import ResetIcon from "../../assets/images/end_convo.svg";
import Logo from "../../assets/images/logo.svg";

import "./styles.scss";
import { appConfig } from "shared/app-config";

const createTitleProps = (title = "", position = "center") => ({
    title,
    position,
});

const TranscriptControl = ({
    conversationMode = false,
    listeningStatus,
    onDownloadTranscript,
    onConversationClick,
    onRecordingClick,
    onResetClick,
    conversation
}) => {
    let [btnTitleProps, setBtnTitleProps] = useState(createTitleProps());

    const getCenterBtnIcon = () => {
        switch (listeningStatus) {
            case ListeningStatus.Listening:
                return StopRecordingIcon;

            default:
                return StartRecordingIcon;
        }
    };

    return (
        <div className="d-flex flex-column align-items-center gap-3">
            {/* Uncomment below code to enable transcript */}
            {(appConfig.DOWNLOAD_TRANSCRIPT_ENABLED === 'true' && conversation?.length) ? <Button
                variant="link"
                className="rounded-5"
                onClick={onDownloadTranscript}
            >
                Download transcript
            </Button> : ""}
            <img
                src={Logo}
                width={150}
                className="d-block d-lg-none" alt="download script"
            />
            <div className="pill-control position-relative">
                <Button
                    variant="light"
                    className={`pill-btn left ${conversationMode ? "clicked" : ""}`}
                    onClick={onConversationClick}
                    disabled={!conversation.length}
                    onMouseEnter={() => setBtnTitleProps(createTitleProps("Conversation", "left"))}
                    onMouseLeave={() => setBtnTitleProps(createTitleProps())}
                >
                    <img
                        src={ChatIcon}
                        alt="chat icon"
                    />
                </Button>

                <Button
                    variant="light"
                    className={`pill-btn center ${listeningStatus === ListeningStatus.Listening ? "pulsing stop-recording" : "start-recording"}`}
                    onClick={onRecordingClick}
                    disabled={listeningStatus === ListeningStatus.Preparing}
                    onMouseEnter={() => setBtnTitleProps(createTitleProps(listeningStatus === ListeningStatus.Listening ? "Stop Listening" : "Listen"))}
                    onMouseLeave={() => setBtnTitleProps(createTitleProps())}
                >
                    <img
                        src={getCenterBtnIcon()}
                        alt="center button icon"
                    />
                </Button>

                <Button
                    variant="light"
                    className="pill-btn right"
                    onClick={onResetClick}
                    disabled={!conversation.length}
                    onMouseEnter={() => setBtnTitleProps(createTitleProps("End Conversation", "right"))}
                    onMouseLeave={() => setBtnTitleProps(createTitleProps())}
                >
                    <img
                        src={ResetIcon}
                        alt="reset icon"
                    />
                </Button>
                <div className={`position-absolute btn-title ${btnTitleProps.position}`}>{btnTitleProps.title || (listeningStatus === ListeningStatus.Listening ? "Listening" : "")}</div>
            </div>
        </div>
    );
};

export default TranscriptControl;
